export { default as goatERC20Tokens } from './goatERC20Tokens';
